import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { DropShadowFilter } from "pixi-filters";
import { Container, Text, TextStyle } from "pixi.js";
import { UnboardingType } from "../UnboardingType";

export class ThirdPageHeaderTextContainer extends Container {
    public constructor(type: UnboardingType) {
        super();
        switch (type) {
            case UnboardingType.OWNER:
                this.buildOwnerText();
                break;
            case UnboardingType.RENTER:
                this.buildRenterText();
                break;
        }
    }

    private buildRenterText(): void {
        const headerText = new Text(`PURCHASE YOUR\nOWN BUILDING AND BECOME`, new ContainerTextStyle());
        headerText.style.lineHeight = 60;
        headerText.style.dropShadow = true;
        headerText.style.dropShadowAngle = 0;
        headerText.style.dropShadowBlur = 20;
        headerText.style.dropShadowColor = "#FF00B8";
        headerText.style.dropShadowDistance = -3;
        headerText.style.fontSize = 56.65;
        headerText.angle = -5;
        headerText.skew.x = -0.08;
        headerText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        this.addChild(headerText);
        const ownerText = new Text(`AN OWNER`, new ContainerTextStyle());
        ownerText.style.dropShadow = true;
        ownerText.style.dropShadowAngle = 0;
        ownerText.style.dropShadowBlur = 20;
        ownerText.style.dropShadowColor = "#FF00B8";
        ownerText.style.dropShadowDistance = -3;
        ownerText.style.fontSize = 132;
        ownerText.angle = -5;
        ownerText.skew.x = -0.08;
        ownerText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        ownerText.position.set(29, 110);
        this.addChild(ownerText);
        const boostText = new Text(`TO BOOST YOUR INCOME!`, new ContainerTextStyle());
        boostText.style.lineHeight = 60;
        boostText.style.dropShadow = true;
        boostText.style.dropShadowAngle = 0;
        boostText.style.dropShadowBlur = 20;
        boostText.style.dropShadowColor = "#FF00B8";
        boostText.style.dropShadowDistance = -3;
        boostText.style.fontSize = 56.65;
        boostText.angle = -5;
        boostText.skew.x = -0.08;
        boostText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        boostText.position.set(29, 224);
        this.addChild(boostText);
    }

    private buildOwnerText(): void {
        const headerText = new Text(`BECOME A`, new ContainerTextStyle());
        headerText.style.dropShadow = true;
        headerText.style.dropShadowAngle = 0;
        headerText.style.dropShadowBlur = 20;
        headerText.style.dropShadowColor = "#FF00B8";
        headerText.style.dropShadowDistance = -3;
        headerText.style.fontSize = 53;
        headerText.angle = -5;
        headerText.skew.x = -0.08;
        headerText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        this.addChild(headerText);
        const landlordText = new Text(`LANDLORD`, new ContainerTextStyle());
        landlordText.style.dropShadow = true;
        landlordText.style.dropShadowAngle = 0;
        landlordText.style.dropShadowBlur = 20;
        landlordText.style.dropShadowColor = "#FF00B8";
        landlordText.style.dropShadowDistance = -3;
        landlordText.style.fontSize = 128;
        landlordText.angle = -5;
        landlordText.skew.x = -0.08;
        landlordText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        landlordText.position.set(-122, 64);
        this.addChild(landlordText);
        const additionalText = new Text(`AND COLLECT RENT FROM OTHERS`, new ContainerTextStyle());
        additionalText.style.dropShadow = true;
        additionalText.style.dropShadowAngle = 0;
        additionalText.style.dropShadowBlur = 20;
        additionalText.style.dropShadowColor = "#FF00B8";
        additionalText.style.dropShadowDistance = -3;
        additionalText.style.fontSize = 60;
        additionalText.angle = -5;
        additionalText.skew.x = -0.08;
        additionalText.filters = [new DropShadowFilter({ blur: 4, quality: 4, alpha: 0.8, color: 0xffab5d })];
        additionalText.position.set(-221, 185);
        this.addChild(additionalText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 107,
            fill: 'ffffff',
            align: "center"
        });
    }
}